import "@fullcalendar/core/vdom";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'

import wysiwyg from "vue-wysiwyg";
import VueViewer from "v-viewer";
import { use } from "echarts/core";
import { BarChart, PieChart } from "echarts/charts";
import ECharts from "vue-echarts";

import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from "echarts/components";

import { CanvasRenderer } from "echarts/renderers";
import VueToast from 'vue-toast-notification';
import VueMeta from 'vue-meta';

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

// register globally


// css
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "flatpickr/dist/flatpickr.css";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import "viewerjs/dist/viewer.min.css";
import "@/assets/main.css";


import 'vue-toast-notification/dist/theme-sugar.css';

import axios from "./axios.js";
Vue.prototype.$axios = axios

Vue.config.productionTip = false;
Vue.use(wysiwyg, {});
Vue.use(VueViewer);
import VueSimpleAlert from "vue-simple-alert";
import VueSignaturePad from 'vue-signature-pad';

Vue.use(VueSimpleAlert);
Vue.use(VueToast);

import VueHtml2Canvas from 'vue-html2canvas';
 
Vue.use(VueHtml2Canvas);
Vue.use(VueSignaturePad);
// and others...
use([
  CanvasRenderer,BarChart,PieChart,TitleComponent,GridComponent,TooltipComponent,LegendComponent,
]);
Vue.component("v-chart", ECharts);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
